<template>
  <div>
    <search-tool
      :select-list="statusList"
      input-text="请输入名字"
      add-btn-text="新增操作员"
      @add="add"
      @onSearch="onSearch"
    />
    <a-table
      :columns="columns"
      :data-source="data"
      :pagination="false"
      :loading="boolLoading"
      bordered
    >
      <template
        v-for="col in [
          'name',
          'phone',
          'address',
          'email',
          'comment',
        ]"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :value="text"
            @change="(e) => handleChange(e.target.value, record.key, col)"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template
        slot="logo"
        slot-scope="text"
      >
        <div class="editable-row-operations">
          <div>
            <image-tool
              v-for="(item, index) in text"
              :key="index"
              class="img-list"
              :img-url="item.response.data"
            />
          </div>
        </div>
      </template>
      <template
        slot="status"
        slot-scope="text"
      >
        <div class="editable-row-operations">
          <a-tag
            v-if="text == 'on'"
            color="blue"
          >
            正常
          </a-tag>
          <a-tag
            v-else
            color="red"
          >
            关闭
          </a-tag>
        </div>
      </template>
      <template
        slot="operation"
        slot-scope="text, record"
      >
        <div class="editable-row-operations">
          <span>
            <a
              :disabled="editingKey !== ''"
              @click="onEdit(record)"
            >编辑</a>
          </span>
          <span>
            <a
              :disabled="editingKey !== ''"
              @click="openChangePasswordForm(record)"
            >密码</a>
          </span>
          <span>
            <a
              :disabled="editingKey !== ''"
              @click="() => status(record)"
            >{{
              record.status == "on" ? "关闭" : "恢复"
            }}</a>
          </span>
        </div>
      </template>
    </a-table>
    <a-pagination
      v-model="page"
      class="pagination"
      show-quick-jumper
      :default-current="1"
      :page-size="20"
      :total="total"
      @change="onFetchOperators"
    />

    <operator-form
      ref="shopForm"
      @handleOk="onAddShop"
      @handleEditOk="onUpdateShop"
    />
    <shop-password-form
      ref="shopPasswordForm"
      @handleOk="handleSetPassword"
    />
  </div>
</template>

<script>
const columns = [
  {
    title: 'username',
    dataIndex: 'username',
    scopedSlots: { customRender: 'username' },
  },
  {
    title: 'logo(尺寸：170 x 50)',
    dataIndex: 'logo',
    scopedSlots: { customRender: 'logo' },
  },
  {
    title: 'name',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'phone',
    dataIndex: 'phone',
    scopedSlots: { customRender: 'phone' },
  },
  {
    title: 'address',
    dataIndex: 'address',
    scopedSlots: { customRender: 'address' },
  },
  {
    title: 'email',
    dataIndex: 'email',
    scopedSlots: { customRender: 'email' },
  },
  {
    title: 'comment',
    dataIndex: 'comment',
    scopedSlots: { customRender: 'comment' },
  },
  {
    title: 'status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'operation',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: '150px',
  },
];

import ShopServices from '../services/ShopServices';
import searchTool from '../components/searchTool.vue';
import OperatorForm from '../components/operator/OperatorForm.vue';
import imageTool from '../components/imageTool.vue';
import ShopPasswordForm from '@/components/shop/ShopPasswordForm';

export default {
  name: 'Operator',
  components: {
    ShopPasswordForm,
    searchTool,
    OperatorForm,
    imageTool
  },
  data() {
    return {
      total: 0,
      page: 1,
      data: [],
      columns,
      editingKey: '',
      boolLoading: false,
      formSearch: {
        selected: [],
        input: '',
      },
      statusList: [
        { text: '正常', value: ['on'] },
        { text: '关闭', value: ['off'] },
        { text: '不限', value: [] },
      ],
      windowHeight: window.innerHeight,
    };
  },
  created() {
    this.onFetchOperators();
  },
  methods: {
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        target.editable = true;
        this.data = newData;
      }
    },
    add() {
      this.$refs.shopForm.onReset();
      this.$refs.shopForm.visible = !this.$refs.shopForm.visible;
    },
    onSearch(formPass) {
      this.formSearch = formPass;
      this.page = 1;
      this.onFetchOperators();
    },
    onFetchOperators() {
      let that = this;
      var token = that.$cookies.get('fancyToken');
      that.boolLoading = true;
      const request = ShopServices.postAdminFetchOperatorByPage(
        that.page,
        that.formSearch.input,
        that.formSearch.selected,
        token
      );
      request
        .then((res) => {
          if (res.data.code == 201) {
            // 权限限制
            this.$router.push('/').catch(() => {});
          }
          that.total = res.data.data.total;
          that.data = res.data.data.data.map((row) => ({
            key: row.id,
            ...row,
          }));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          that.boolLoading = false;
        });
    },

    onAddShop(form) {
      let that = this;
      var token = that.$cookies.get('fancyToken');
      that.boolLoading = true;
      const request = ShopServices.postAdminInsertOperator(form, token);
      request
        .then((res) => {
          console.log(res);
          if (res.data.code == 500) {
            that.$message.error('新增失败' + res.data.errMsg.errorInfo[2]);
            return;
          }
          that.onFetchOperators();
          that.add();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          that.boolLoading = false;
        });
    },

    onUpdateShop(form) {
      let that = this;
      var token = that.$cookies.get('fancyToken');
      that.boolLoading = true;
      const request = ShopServices.postAdminUpdateOperator(form.id, form, token);
      request
        .then((res) => {
          if (res.data.code == 500) {
            that.$message.error('更新失败' + res.data.errMsg);
            return;
          }
          that.onFetchOperators();
          that.add();
        })
        .catch(() => {
          that.$message.error('更新失败');
          that.onFetchOperators();
        })
        .finally(() => {
          that.boolLoading = false;
        });
    },

    status(record) {
      let that = this;
      var status = 'on';
      if (record.status == 'on') {
        status = 'off';
      }
      var token = that.$cookies.get('fancyToken');
      that.boolLoading = true;
      const request = ShopServices.postAdminUpdateStatusOperator(
        record.key,
        status,
        token
      );
      request
        .then((res) => {
          if (res.data.code == 500) {
            that.$message.error('更新失败');
          }
          that.onFetchOperators();
        })
        .catch(() => {
          that.$message.error('更新失败');
          that.onFetchOperators();
        })
        .finally(() => {
          that.boolLoading = false;
        });
    },
    onEdit(record) {
      this.$refs.shopForm.onSetShop(record);
      this.$refs.shopForm.boolEdit = true;
      this.$refs.shopForm.visible = !this.$refs.shopForm.visible;
    },
    openChangePasswordForm(record) {
      this.$refs.shopPasswordForm.init(record);
    },
    handleSetPassword(form) {
      let that = this;
      var token = that.$cookies.get('fancyToken');
      that.boolLoading = true;
      const request = ShopServices.postAdminSetPassword(form.id, form.password, token);
      request
        .then((res) => {
          if (res.data.code == 500) {
            that.$message.error('更新失败');
          }
          that.onFetchOperators();
          // that.add();
        })
        .catch(() => {
          that.$message.error('更新失败');
          that.onFetchOperators();
        })
        .finally(() => {
          that.boolLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.pagination {
  margin-top: 20px;
}
</style>